import React, { useMemo } from "react";
import DependentsTick from "assets/svgs/dependents_tick.svg";
import DependentsUntick from "assets/svgs/dependents_untick.svg";
import { IconButton } from "@mui/material";
import { colors } from "theme";
import "./styles.css";

const DependentsCard = ({ selected, children, handleClick, disabled = false }) => {
  const style = useMemo(() => {
    return {
      border: `1px solid ${selected ? colors.primaryColor : "#EAECF0"}`,
      backgroundColor: selected ? "#D7CAFF1A" : "transparent",
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? "not-allowed" : "pointer",
    };
  }, [selected, disabled]);
  
  const handleCardClick = () => {
    if (!disabled) {
      handleClick();
    }
  };
  
  return (
    <div
      className="dependents-card-wrapper"
      style={style}
      onClick={handleCardClick}
    >
      {children}
      <IconButton disabled={disabled}>
        <img src={selected ? DependentsTick : DependentsUntick} />
      </IconButton>
    </div>
  );
};

export default DependentsCard;
